var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 0.5C6.5552 0.5 0.5 6.5552 0.5 14C0.5 21.4448 6.5552 27.5 14 27.5C21.4448 27.5 27.5 21.4448 27.5 14C27.5 6.5552 21.4448 0.5 14 0.5ZM14 2.3C20.4722 2.3 25.7 7.5278 25.7 14C25.7 20.4722 20.4722 25.7 14 25.7C7.5278 25.7 2.3 20.4722 2.3 14C2.3 7.5278 7.5278 2.3 14 2.3ZM10.1 8V20L20.3 14L10.1 8Z","fill":"white"}));
}

PlayInline.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
